import React from 'react';
import './_simplePage.scss';

interface ISimplePage {
  title?: string;
  children: React.ReactNode;
}

const SimplePage = (props: ISimplePage) => {
  const { title, children } = props;
  return (
    <div className="simple-page col-md-8 offset-md-2 col-sm-12">
      {title && <h1 className="simple-page__title">{title}</h1>}
      {children}
    </div>
  );
};

export default SimplePage;
